
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/bank-transfer-results",
      function () {
        return require("private-next-pages/admin/bank-transfer-results/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/bank-transfer-results"])
      });
    }
  